module.exports = __webpack_public_path__ + "src/client/assets/img/download-googleplay.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/img/download-googleplay.png
// module id = 1203
// module chunks = 0